/**
 * Labstep
 *
 * @module components/Layout/FullPageMessage
 * @desc Generic Component for displaying page errors
 */

import { Header } from 'labstep-web/core/Header';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { LayoutFullPageMessageProps } from './types';

export const LayoutFullPageMessage: React.FC<
  LayoutFullPageMessageProps
> = ({ src, title, explanation, action, additional }) => (
  <div className={styles.container}>
    <Image className={styles.image} centered src={src} />
    <Header size="large">{title}</Header>
    <Header size="small">{explanation}</Header>
    {action}
    <br />
    {additional}
  </div>
);
